module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1159.674f7274.jpg";